import { Badge, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { Business } from 'services/@types';
import { getActiveBusinesses, formatLastSeen } from './analyticsUtils';
import { useNavigate } from 'react-router-dom';

interface Props {
  businesses: Business[];
}

export default function ActiveContractsCard({ businesses }: Props) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const navigate = useNavigate();
  const active = getActiveBusinesses(businesses, 10);

  return (
    <Card p="20px" flex="1" minW="300px">
      <Text color={textColor} fontSize="lg" fontWeight="700" mb="16px">
        Most Active by Contracts
      </Text>
      {active.length === 0 && (
        <Text color="gray.400" fontSize="sm">No active contracts</Text>
      )}
      {active.map((b, i) => (
        <Flex
          key={b.id || i}
          justify="space-between"
          align="center"
          py="8px"
          borderBottom="1px solid"
          borderColor="gray.100"
          cursor="pointer"
          _hover={{ bg: 'gray.50' }}
          onClick={() => b.id && navigate(`/admin/businesses/detail/${b.id}`)}
        >
          <Flex direction="column">
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {b.businessName}
            </Text>
            <Text color="gray.400" fontSize="xs">
              {formatLastSeen(b.createdAt)}
            </Text>
          </Flex>
          <Badge colorScheme="green" fontSize="xs">
            {b.subscription?.type || 'active'}
          </Badge>
        </Flex>
      ))}
    </Card>
  );
}
